import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { processData } from '../../data';
import { processDataArabic } from '../../data/indexArabic';
import { useAuth } from '../../store/auth';

const ProcessSection = () => {
  const { isArabic } = useAuth();
  const data = isArabic ? processData : processDataArabic;

  return (
    <React.Fragment>
      {data && (
        <Container>
          <Row className="justify-content-center">
            <Col className="col-12 text-center">
              <div className="section-title mb-4 pb-2">
                <span className="badge rounded-pill bg-soft-primary">{data?.badgeText}</span>
                <h4 className="title mt-3 mb-4">
                  {data?.titles?.map((ele, index) => (
                    <span key={index} className={ele.highlight ? 'text-primary' : ''}>
                      {ele.breakPoint && <br />}
                      {ele.title}
                    </span>
                  ))}
                </h4>
                <p className="text-muted para-desc mb-0 mx-auto">
                  {data?.description?.map((ele, index) => (
                    <span className={ele.highlight ? 'text-primary fw-bold' : ''} key={index}>
                      {ele.content}
                    </span>
                  ))}
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {data?.steps?.map((step, key) => (
              <Col key={key} lg={3} md={6} className="mt-4 pt-2">
                <Card className="features feature-primary text-center border-0 rounded-3 shadow-sm p-4 h-100">
                  <div className="position-relative">
                    <div className="image position-relative d-inline-block mb-4">
                      <div className="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto" style={{ width: '80px', height: '80px' }}>
                        <FeatherIcon icon={step.icon} className="text-primary" size={32} />
                      </div>
                      <div className="position-absolute top-0 start-100 translate-middle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', fontSize: '14px', fontWeight: 'bold' }}>
                        {step.stepNumber}
                      </div>
                    </div>
                  </div>
                  <CardBody className="p-0">
                    <h5 className="title mb-3">{step.title}</h5>
                    <p className="text-muted mb-0">{step.description}</p>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Process Flow Connection Line - Hidden on mobile */}
          <div className="d-none d-lg-block">
            <div className="position-relative mt-5">
              <div className="process-line position-absolute top-50 start-0 w-100" style={{ height: '2px', background: 'linear-gradient(to right, #3498db, #e74c3c)', zIndex: '-1' }}></div>
            </div>
          </div>
        </Container>
      )}
    </React.Fragment>
  );
};

export default ProcessSection;
